module.exports = __webpack_public_path__ + "static/img/s150.5d92c566.png";